import FieldPopover from "../../popover/popover"
import FieldConfig from "../../../proto/field-config"
import formatDate from "../../../../gd/format/date"
import FieldDatetime_View from "./render/view"
import FieldDatetime_ViewSmall from "./render/view-small"
import DatetimeUtils from "../../../../gd/utils/datetime-utils"
import {GROUP_DATE_TIME} from "../../../../gd/const/fields/field2-groups"
import normalizeDate from "../../../import/normalize/normalize-date"
import ImportFromCSVModule from "../../../../gd-modules/import-from-csv/import-from-csv-module"
import {FieldFilterType} from "../../../proto/types"
import {
    ConditionType_DateFixedAfter,
    ConditionType_DateFixedBefore, ConditionType_DateFixedEquals, ConditionType_DateFixedRange,
    ConditionType_DateRelativeAfter,
    ConditionType_DateRelativeBefore, ConditionType_DateRelativeEquals, ConditionType_DateRelativeRange
} from "../../../../model2/conditions/condition-types"
import SessionCustomField from "../../../../model2/custom-field/session-custom-field";
import {FieldType} from "../../../field-type";
import FieldDateAndTime_ManagementFormCFV1 from "./render/management/management-form-cfv1";
import CustomFieldsV1 from "../../../../gd/const/fields/custom-fields-v1";
import FieldDatetime_Editable from "./render/editable/editable";
import FieldDatetime_Popover from "./components/popover/popover";
import formatTime from "../../../../gd/format/time";
import FieldDropdown_PopoverOption from "../../dropdown/components/option/option";
import FieldDatetime_ManagementPreview from "./render/management/management-preview";
import FieldDatetime_InlineEditable from "./render/inline-editable";
import AggregateMoment from "../../../../fields/aggregate/aggregate-moment";
import AggregateMomentDateTimeComponent from "../../../../fields/system/components/aggregate-moment-datetime";
import FieldDatetime_FormElementView from "./render/form-element-view";
import FieldDatetime_FormElement from "./render/form-element";
import FieldDatetime_FormValueEmpty from "./components/form/value-empty";
import FieldDatetime_FormValueNotEmpty from "./components/form/value-not-empty";
import FieldDatetime_ManagementForm from "./render/management/management-form"
import FieldDatetime_ViewProperty from "./render/property"
import { Date_GroupingOptions } from "../../../system/task/date/@const"
import GroupBy from "../../../../gd/manager/group-by/group-by-model"
import { getIntervalValue } from "../../../../gd/utils/datetime/get-interval-value"
import { getIntervalLabel } from "../../../../gd/utils/datetime/get-interval-label"
import { DateTimeValue } from "./@type"
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types"
import FieldDatetime_AggregateCell from "./render/aggregate/aggregate-cell"
import FieldDatetime_TableCellCalculated from "./render/table/table-cell-calculated"
import FieldDatetime_BoardAggregate from "./render/aggregate/board-aggregate";

export default class FieldDatetime extends FieldPopover {

    // public minDate?             : Moment
    // public maxDate?             : Moment

    constructor(config:FieldConfig) {
        super(config);

        this.typeInteger        = CustomFieldsV1.type.DATE_AND_TIME
        this.typeLabel          = "Datetime";
        this.filterType         = FieldFilterType.DATE;
        this.typeGroup          = GROUP_DATE_TIME;
        this.typeDescription    = "Generic datetime picker field";
        this.icon               = _.get(config,'icon','i5-deadline')

        this.isFilterAvailable  = false

        this.minDate            = _.get(config, 'minDate', undefined)       // if set popover calendar disables past minDate
        this.maxDate            = _.get(config, 'maxDate', undefined)       // is set -> disabled future maxDate

        this.conditionTypes     = [
            ConditionType_DateRelativeBefore, ConditionType_DateRelativeAfter, ConditionType_DateRelativeEquals, ConditionType_DateRelativeRange,
            ConditionType_DateFixedBefore, ConditionType_DateFixedAfter, ConditionType_DateFixedEquals, ConditionType_DateFixedRange,
        ]

        this.clearButton        = _.get(config,'clearButton',true);

        this.hasCalculatedValues                    = true

        this.components.PopoverMenu                 = FieldDatetime_Popover
        this.components.PopoverOption               = FieldDropdown_PopoverOption
        this.components.FormValueEmpty              = FieldDatetime_FormValueEmpty
        this.components.FormValueNotEmpty           = FieldDatetime_FormValueNotEmpty

        this.renderComponents.view                  = FieldDatetime_View
        this.renderComponents.viewSmall             = FieldDatetime_ViewSmall
        this.renderComponents.viewProperty          = FieldDatetime_ViewProperty
        this.renderComponents.editable              = FieldDatetime_Editable
        this.renderComponents.inlineEditable        = FieldDatetime_InlineEditable
        this.renderComponents.managementPreview     = FieldDatetime_ManagementPreview
        this.renderComponents.managementForm        = FieldDatetime_ManagementForm
        this.renderComponents.managementFormCFV1    = FieldDateAndTime_ManagementFormCFV1
        this.renderComponents.formElement           = FieldDatetime_FormElement
        this.renderComponents.formElementView       = FieldDatetime_FormElementView

        this.renderComponents.tableCellCalculated   = FieldDatetime_TableCellCalculated
        this.renderComponents.aggregateCell         = FieldDatetime_AggregateCell
        this.renderComponents.boardAggregate        = FieldDatetime_BoardAggregate

        this.modifierOptions            = Date_GroupingOptions
        this.modifierOptionParamName    = 'interval'

    }

    static initFromCustomFieldV1(customFieldV1:SessionCustomField) {
        return new FieldDatetime({
            fieldId         : customFieldV1.id,
            type            : FieldType.DATE_AND_TIME,
            fieldParams     : customFieldV1.params,
            fieldAccess     : customFieldV1.access
        })
    }

    getViewValue(model: any){

        const data = _.get(model, this.fieldId, null)

        if(!data){
            return {
                date: null,
                time: null,
            }
        }

        return {
            date: moment(data.date),
            time: data.time ? moment(data.time) : null
        }
    }

    getDisplayValue(value:any) {
        if (!value) return false

        const date = formatDate(DatetimeUtils.dateToMoment(value.date))

        let time = null

        if(value.time){
            time = formatTime(moment(value.time))
            return date + "  " + time
        }

        return formatDate(DatetimeUtils.dateToMoment(value.date))
    }

    getCsvValue(value:any, listItem?:any) {
        const viewValue = this.getViewValue(value)

        return this.getDisplayValue(viewValue)
    }

    sortValue(value:any) { return value ? DatetimeUtils.dateToMoment(value).format('x') : 0; }


    groupValue(value:DateTimeValue, groupBy?:GroupBy) {
        if (!value) return null

        return getIntervalValue(value.date, groupBy)
    }

    groupLabel(value: DateTimeValue, groupBy?:GroupBy): string {
        if (!value) return 'Not set'

        return getIntervalLabel(value.date, groupBy)
    }

    // groupValue(value:any) {
    //     if (!value) return null
    //     return formatDate(DatetimeUtils.dateToMoment(value))
    // }

    // groupLabel(value: any): string {
    //     if (!value) return 'Not set'
    //     return formatDate(DatetimeUtils.dateToMoment(value))
    // }

    automationGetValuesForDescription(value:any) {
        if (!value) {
            return ['trigger day']
        } else {
            return ['{0} {1} {2} trigger day'.f(Math.abs(value), [-1,1].includes(value) ? 'day' : 'days', value < 0 ? 'before' : 'after')]
        }
    }

    normalizeToCSVValue(model: any): any {
        const rawValue = super.normalizeToCSVValue(model)
        const res: string | null = !_.isEmpty(rawValue) ? DatetimeUtils.momentToDate(momentDate(rawValue)) : null
        return !!res ? res : ''
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        return normalizeDate(value)
    }

    get AggregateComponent() {return AggregateMomentDateTimeComponent.bind(null, this.getAggregateOptions())}

    getAggregateValue(model:any) {
        return this.getViewValue(model)?.date
    }

    getAggregateClass() {
        return AggregateMoment
    }

    getAggregateOptions() {return [
        AggregateFunctionType.DATE_MIN,
        AggregateFunctionType.DATE_MAX,
        AggregateFunctionType.DATE_RANGE,
    ]}
}
